import React, { useState, useEffect } from "react";
import { Card, Badge } from "react-bootstrap";
import {
    BrokerCoinswitchHoldings,
    BrokerCoinswitchWallet,
    BrokerCoinswitchOpenPosition,
    BrokerCoinswitchTransactions,
    BrokerCoinswitchFuturesWalletBalance,
} from "../../../Service/Broker.service.jsx";

import Swal from "sweetalert2";

import DataTable from "react-data-table-component";

const Wallet = () => {
    const user_details = JSON.parse(localStorage.getItem("user_details"));
    const gotodashboard = JSON.parse(localStorage.getItem("gotodashboard"));
    const UserNamego_localstg = JSON.parse(
        localStorage.getItem("user_details_goTo")
    );
    const [walletdata, setWalletdata] = useState([]);
    const [futurewalletdata, setFuturewalletdata] = useState([]);
    const [positiondata, setPositiondata] = useState({
        summary: {},
        data: []
    });

    const [transactions, setTransactions] = useState([]);
    const [holding, setHolding] = useState([]);
    const [loading, setLoading] = useState({
        wallet: false,
        positions: false,
        transactions: false,
        holdings: false,
    });


    useEffect(() => {
        if (user_details?.user_id) {
            getWallet();
            getPosition();
            getTransaction();
            getHolding();
        } else {
            Swal.fire({
                icon: "warning",
                title: "User Not Found",
                text: "Please login again to access wallet data.",
            });
        }
    }, []);


    // ✅ FIXED: Properly handles array data from response.data.data
    const getWallet = async () => {
        try {
            setLoading((prev) => ({ ...prev, wallet: true }));
            // const data = { _id: user_details?.user_id };
            const data = {
                _id: gotodashboard
                    ? UserNamego_localstg.user_id
                    : user_details?.user_id,

            };
            const response = await BrokerCoinswitchWallet(data);
            if (response?.status && response?.data?.data) {
                setWalletdata(response?.data?.data);
            } else {
                setWalletdata([]);
            }
        } catch (error) {
            console.error("Error fetching wallet:", error);
            setWalletdata([]);
        } finally {
            setLoading((prev) => ({ ...prev, wallet: false }));
        }
    };

    const getfuturewallet = async () => {
        try {
            setLoading((prev) => ({ ...prev, wallet: true }));
            // const data = { _id: user_details?.user_id };
            const data = {
                _id: gotodashboard
                    ? UserNamego_localstg.user_id
                    : user_details?.user_id,

            };
            const response = await BrokerCoinswitchFuturesWalletBalance(data);
            if (response?.status && response?.data?.data) {
                setFuturewalletdata(response?.data?.data);
            } else {
                setFuturewalletdata([]);
            }
        } catch (error) {
            console.error("Error fetching wallet:", error);
            setFuturewalletdata([]);
        } finally {
            setLoading((prev) => ({ ...prev, wallet: false }));
        }
    };


    const getPosition = async () => {
        try {
            setLoading((prev) => ({ ...prev, positions: true }));

            const data = {
                userid: gotodashboard
                    ? UserNamego_localstg.user_id
                    : user_details?.user_id
            };

            const response = await BrokerCoinswitchOpenPosition(data);

            if (response?.status === true) {
                setPositiondata({
                    summary: response.summary || {},
                    data: response.data || []
                });
            } else {
                setPositiondata({ summary: {}, data: [] });
            }

        } catch (error) {
            console.error("Error fetching positions:", error);
            setPositiondata({ summary: {}, data: [] });
        } finally {
            setLoading((prev) => ({ ...prev, positions: false }));
        }
    };





    const getTransaction = async () => {
        try {
            setLoading((prev) => ({ ...prev, transactions: true }));
            const data = {
                userid: gotodashboard
                    ? UserNamego_localstg.user_id
                    : user_details?.user_id,
                symbol: '',
                exchange: "EXCHANGE_2",
                type: "",
                transaction_id: ""
            };
            const response = await BrokerCoinswitchTransactions(data);
            if (response.status) {
                setTransactions(response);
            } else {
                setTransactions([]);
            }
        } catch (error) {
            console.error("Error fetching transactions:", error);
            setTransactions([]);
        } finally {
            setLoading((prev) => ({ ...prev, transactions: false }));
        }
    };

    const getHolding = async () => {
        try {
            setLoading((prev) => ({ ...prev, holdings: true }));
            const data = {
                userid: gotodashboard
                    ? UserNamego_localstg.user_id
                    : user_details?.user_id
            };
            const response = await BrokerCoinswitchHoldings(data);
            if (response.status) {
                setHolding(response);
            } else {
                setHolding([]);
            }
        } catch (error) {
            console.error("Error fetching holdings:", error);
            setHolding([]);
        } finally {
            setLoading((prev) => ({ ...prev, holdings: false }));
        }
    };


    const LoadingSpinner = () => (
        <div className="d-flex justify-content-center align-items-center py-4">
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    );

    const columns = [
        {
            name: "#",
            selector: (row, index) => index + 1,
            sortable: true,
            width: "70px",
            cell: (row, index) => (
                <span className="badge text-dark" style={{ borderRadius: "8px", padding: "6px 10px" }}>
                    {index + 1}
                </span>
            ),
        },
        {
            name: "Date",
            selector: (row) => row.timestamp,
            sortable: true,
            grow: 2,
            cell: (row) => (
                <div>
                    <div className="fw-bold" style={{ color: "#2c3e50", fontSize: "14px" }}>
                        {new Date(row.timestamp).toLocaleDateString()}
                    </div>
                    <small>{new Date(row.timestamp).toLocaleTimeString()}</small>
                </div>
            ),
        },
        {
            name: "Type",
            selector: (row) => row.type,
            sortable: true,
            cell: (row) => <span className="fw-bold">{row.type}</span>,
        },
        {
            name: "Amount",
            selector: (row) => row.formatted_amount,
            sortable: true,
            cell: (row) => (
                <span className={row.is_credit ? "text-success fw-bold" : "text-danger fw-bold"}>
                    {row.is_credit ? "+" : "-"} {row.formatted_amount}
                </span>
            ),
        },
        {
            name: "Symbol",
            selector: (row) => row.symbol,
            sortable: true,
            cell: (row) => <span className="fw-bold">{row.symbol || "-"}</span>,
        },
        {
            name: "Status",
            sortable: false,
            cell: () => (
                <span
                    style={{
                        background: "#28a745",
                        color: "white",
                        borderRadius: "20px",
                        padding: "8px 16px",
                        fontSize: "14px",
                    }}
                >
                    ✅ Completed
                </span>
            ),
        },
    ];

    return (
        <div>
            <div className="container-fluid p-0">
                {/* Header */}
                <div className="mb-4">
                    <h5 className="fw-bold mb-1">🔺 CoinSwitch Wallet</h5>
                    <p className="mb-0">Manage your CoinSwitch trading account</p>
                </div>

                <Card
                    className="shadow-lg border-0"
                    style={{ borderRadius: "20px", overflow: "hidden" }}
                >
                    <div
                        style={{
                            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                            padding: "15px",
                        }}
                    >
                        <div className="row g-3">

                            {/* Available Balance */}
                            <div className="col-6 col-md-4">
                                <div
                                    className="text-center p-3 h-100"
                                    style={{
                                        backgroundColor: "rgba(255,255,255,0.15)",
                                        backdropFilter: "blur(10px)",
                                        borderRadius: "15px",
                                        border: "1px solid rgba(255,255,255,0.2)",
                                        minHeight: "150px",
                                    }}
                                >
                                    <div className="mb-2">
                                        <div
                                            className="d-inline-flex align-items-center justify-content-center"
                                            style={{
                                                width: "45px",
                                                height: "45px",
                                                backgroundColor: "rgba(255,255,255,0.2)",
                                                borderRadius: "50%",
                                            }}
                                        >
                                            <span style={{ fontSize: "20px" }}>💰</span>
                                        </div>
                                    </div>

                                    <h6 className="text-white-50 mb-1" style={{ fontSize: "12px" }}>
                                        Available Balance
                                    </h6>

                                    {loading?.wallet ? (
                                        <div className="text-white" style={{ fontSize: "14px" }}>Loading...</div>
                                    ) : (
                                        <>
                                            <h3 className="text-white fw-bold mb-1" style={{ fontSize: "18px" }}>
                                                {Number(walletdata[0]?.main_balance || 0).toLocaleString(undefined, {
                                                    minimumFractionDigits: 3,
                                                    maximumFractionDigits: 3,
                                                })}
                                            </h3>
                                            <small className="text-white-50" style={{ fontSize: "11px" }}>
                                                {walletdata[0]?.currency || "INR"}
                                            </small>
                                        </>
                                    )}
                                </div>
                            </div>

                            {/* Total Balance */}
                            <div className="col-6 col-md-4">
                                <div
                                    className="text-center p-3 h-100"
                                    style={{
                                        backgroundColor: "rgba(255,255,255,0.15)",
                                        backdropFilter: "blur(10px)",
                                        borderRadius: "15px",
                                        border: "1px solid rgba(255,255,255,0.2)",
                                        minHeight: "150px",
                                    }}
                                >
                                    <div className="mb-2">
                                        <div
                                            className="d-inline-flex align-items-center justify-content-center"
                                            style={{
                                                width: "45px",
                                                height: "45px",
                                                backgroundColor: "rgba(255,255,255,0.2)",
                                                borderRadius: "50%",
                                            }}
                                        >
                                            <span style={{ fontSize: "20px" }}>📊</span>
                                        </div>
                                    </div>

                                    <h6 className="text-white-50 mb-1" style={{ fontSize: "12px" }}>
                                        Total Balance
                                    </h6>

                                    {loading.wallet ? (
                                        <div className="text-white" style={{ fontSize: "14px" }}>Loading...</div>
                                    ) : (
                                        <>
                                            <h3 className="text-white fw-bold mb-1" style={{ fontSize: "18px" }}>
                                                {Number(
                                                    (walletdata[0]?.main_balance || 0) +
                                                    (walletdata[0]?.blocked_balance_order || 0)
                                                ).toLocaleString(undefined, {
                                                    minimumFractionDigits: 3,
                                                    maximumFractionDigits: 3,
                                                })}
                                            </h3>
                                            <small className="text-white-50" style={{ fontSize: "11px" }}>
                                                {walletdata[0]?.currency || "INR"}
                                            </small>
                                        </>
                                    )}
                                </div>
                            </div>

                            {/* Blocked Balance */}
                            <div className="col-6 col-md-4">
                                <div
                                    className="text-center p-3 h-100"
                                    style={{
                                        backgroundColor: "rgba(255,255,255,0.15)",
                                        backdropFilter: "blur(10px)",
                                        borderRadius: "15px",
                                        border: "1px solid rgba(255,255,255,0.2)",
                                        minHeight: "150px",
                                    }}
                                >
                                    <div className="mb-2">
                                        <div
                                            className="d-inline-flex align-items-center justify-content-center"
                                            style={{
                                                width: "45px",
                                                height: "45px",
                                                backgroundColor: "rgba(255,255,255,0.2)",
                                                borderRadius: "50%",
                                            }}
                                        >
                                            <span style={{ fontSize: "20px" }}>🔒</span>
                                        </div>
                                    </div>

                                    <h6 className="text-white-50 mb-1" style={{ fontSize: "12px" }}>
                                        Blocked Balance
                                    </h6>

                                    {loading.wallet ? (
                                        <div className="text-white" style={{ fontSize: "14px" }}>Loading...</div>
                                    ) : (
                                        <h3 className="text-white fw-bold mb-1" style={{ fontSize: "18px" }}>
                                            {Number(walletdata[0]?.blocked_balance_order || 0).toLocaleString(
                                                undefined,
                                                {
                                                    minimumFractionDigits: 3,
                                                    maximumFractionDigits: 3,
                                                }
                                            )}
                                        </h3>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="p-3">
                        {/* Position Section */}
                        <div className="mb-5">
                            <div className="d-flex align-items-center mb-4">
                                <div
                                    className="d-inline-flex align-items-center justify-content-center me-3"
                                    style={{
                                        width: "50px",
                                        height: "50px",
                                        backgroundColor: "#fff3e0",
                                        borderRadius: "15px",
                                    }}
                                >
                                    <span style={{ fontSize: "20px" }}>📊</span>
                                </div>

                                <div>
                                    <h5 className="mb-1 fw-bold">Active Positions</h5>
                                    <small className="">Your current trading positions</small>
                                </div>
                            </div>

                            {positiondata?.summary && (
                                <div
                                    className="d-flex flex-wrap gap-3 mb-4 p-3 "
                                    style={{
                                        background: "#f9fafb",
                                        borderRadius: "15px",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <div>
                                        <h6 className="mb-0 fw-bold">Total Positions:</h6>
                                        <span>{positiondata?.summary?.total_positions}</span>
                                    </div>
                                    <div>
                                        <h6 className="mb-0 fw-bold text-success">Long Positions:</h6>
                                        <span>{positiondata?.summary.long_positions}</span>
                                    </div>
                                    <div>
                                        <h6 className="mb-0 fw-bold text-danger">Short Positions:</h6>
                                        <span>{positiondata?.summary.short_positions}</span>
                                    </div>
                                    <div>
                                        <h6 className="mb-0 fw-bold text-primary">Unrealized P&L:</h6>
                                        <span>{positiondata?.summary.total_unrealized_pnl}</span>
                                    </div>
                                </div>
                            )}

                            {loading?.positions ? (
                                <LoadingSpinner />
                            ) : positiondata?.data?.length === 0 ? (
                                <div className="text-center py-5" style={{ borderRadius: "15px" }}>
                                    <div style={{ fontSize: "48px", marginBottom: "16px" }}>📈</div>
                                    <p className="mb-0">No positions available.</p>
                                </div>
                            ) : (
                                <div
                                    className="react-bootstrap-table mb-4"
                                    style={{
                                        borderRadius: "15px",
                                        overflow: "hidden",
                                        boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                                    }}
                                >
                                    <table className="table mb-0">
                                        <thead>
                                            <tr>
                                                <th className="border-0 py-3" style={{ fontWeight: "600", color: "#6c757d" }}>#</th>
                                                <th className="border-0 py-3" style={{ fontWeight: "600", color: "#6c757d" }}>Symbol</th>
                                                <th className="border-0 py-3" style={{ fontWeight: "600", color: "#6c757d" }}>Side</th>
                                                <th className="border-0 py-3" style={{ fontWeight: "600", color: "#6c757d" }}>Leverage</th>
                                                <th className="border-0 py-3" style={{ fontWeight: "600", color: "#6c757d" }}>Entry Price</th>
                                                <th className="border-0 py-3" style={{ fontWeight: "600", color: "#6c757d" }}>Mark Price</th>
                                                <th className="border-0 py-3" style={{ fontWeight: "600", color: "#6c757d" }}>Size</th>
                                                <th className="border-0 py-3" style={{ fontWeight: "600", color: "#6c757d" }}>Unrealized P&L</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {positiondata?.data?.map((pos, index) => (
                                                <tr key={index} style={{ borderBottom: "1px solid #f0f0f0" }}>
                                                    <td className="py-3 px-4">
                                                        <span className="badge text-dark" style={{ borderRadius: "8px", padding: "6px 10px" }}>
                                                            {index + 1}
                                                        </span>
                                                    </td>
                                                    <td className="py-3 fw-bold text-primary">{pos?.symbol}</td>
                                                    <td className="py-3">
                                                        <Badge
                                                            bg={pos.is_long ? "success" : "danger"}
                                                            style={{ borderRadius: "20px", padding: "6px 12px" }}
                                                        >
                                                            {pos.is_long ? "📈 Long" : "📉 Short"}
                                                        </Badge>
                                                    </td>
                                                    <td className="py-3">{pos.leverage}x</td>
                                                    <td className="py-3">{pos.avg_entry_price}</td>
                                                    <td className="py-3">{pos.mark_price}</td>
                                                    <td className="py-3">
                                                        <Badge
                                                            bg="info"
                                                            style={{ borderRadius: "20px", padding: "8px 16px" }}
                                                        >
                                                            {pos.position_size}
                                                        </Badge>
                                                    </td>
                                                    <td className="py-3">
                                                        <span
                                                            className={
                                                                parseFloat(pos.unrealized_pnl) >= 0
                                                                    ? "text-success fw-bold"
                                                                    : "text-danger fw-bold"
                                                            }
                                                        >
                                                            {parseFloat(pos.unrealized_pnl) >= 0 ? "+" : "-"}
                                                            {Math.abs(parseFloat(pos.unrealized_pnl)).toFixed(2)}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>


                        <div className="mb-5 ">
                            <div className="d-flex align-items-center mt-4 mb-4  ">
                                <div
                                    className="d-inline-flex align-items-center justify-content-center me-3"
                                    style={{
                                        width: "50px",
                                        height: "50px",
                                        backgroundColor: "#fff3e0",
                                        borderRadius: "15px",
                                    }}
                                >
                                    <span style={{ fontSize: "20px" }}>📊</span>
                                </div>

                                <div>
                                    <h5 className="mb-1 fw-bold">Holding</h5>
                                    <small className="">Your Holding positions</small>
                                </div>
                            </div>

                            {holding?.length && (
                                <div
                                    className="d-flex flex-wrap gap-3 mb-4 p-3"
                                    style={{
                                        background: "#f9fafb",
                                        borderRadius: "15px",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                    }}
                                >
                                    <div>
                                        <h6 className="mb-0 fw-bold">Total Positions:</h6>
                                        <span>{holding?.summary?.total_positions}</span>
                                    </div>
                                    <div>
                                        <h6 className="mb-0 fw-bold text-success">Long Positions:</h6>
                                        <span>{holding?.summary.long_positions}</span>
                                    </div>
                                    <div>
                                        <h6 className="mb-0 fw-bold text-danger">Short Positions:</h6>
                                        <span>{holding?.summary.short_positions}</span>
                                    </div>
                                    <div>
                                        <h6 className="mb-0 fw-bold text-primary">Unrealized P&L:</h6>
                                        <span>{holding?.summary.total_unrealized_pnl}</span>
                                    </div>
                                </div>
                            )}

                            {loading.holding ? (
                                <LoadingSpinner />
                            ) : holding?.data?.length === 0 ? (
                                <div className="text-center py-5" style={{ borderRadius: "15px" }}>
                                    <div style={{ fontSize: "48px", marginBottom: "16px" }}>📈</div>
                                    <p className="mb-0">No Holding available.</p>
                                </div>
                            ) : (
                                <div
                                    className="react-bootstrap-table mb-4"
                                    style={{
                                        borderRadius: "15px",
                                        overflow: "hidden",
                                        boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                                    }}
                                >
                                    <table className="table mb-0">
                                        <thead>
                                            <tr>
                                                <th className="border-0 py-3 px-4" style={{ fontWeight: "600", color: "#6c757d" }}>#</th>
                                                <th className="border-0 py-3" style={{ fontWeight: "600", color: "#6c757d" }}>Symbol</th>
                                                <th className="border-0 py-3" style={{ fontWeight: "600", color: "#6c757d" }}>Side</th>
                                                <th className="border-0 py-3" style={{ fontWeight: "600", color: "#6c757d" }}>Leverage</th>
                                                <th className="border-0 py-3" style={{ fontWeight: "600", color: "#6c757d" }}>Entry Price</th>
                                                <th className="border-0 py-3" style={{ fontWeight: "600", color: "#6c757d" }}>Mark Price</th>
                                                <th className="border-0 py-3" style={{ fontWeight: "600", color: "#6c757d" }}>Size</th>
                                                <th className="border-0 py-3" style={{ fontWeight: "600", color: "#6c757d" }}>Unrealized P&L</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {holding?.data?.map((pos, index) => (
                                                <tr key={index} style={{ borderBottom: "1px solid #f0f0f0" }}>
                                                    <td className="py-3 px-4">
                                                        <span className="badge text-dark" style={{ borderRadius: "8px", padding: "6px 10px" }}>
                                                            {index + 1}
                                                        </span>
                                                    </td>
                                                    <td className="py-3 fw-bold text-primary">{pos?.symbol}</td>
                                                    <td className="py-3">
                                                        <Badge
                                                            bg={pos.is_long ? "success" : "danger"}
                                                            style={{ borderRadius: "20px", padding: "6px 12px" }}
                                                        >
                                                            {pos.is_long ? "📈 Long" : "📉 Short"}
                                                        </Badge>
                                                    </td>
                                                    <td className="py-3">{pos.leverage}x</td>
                                                    <td className="py-3">{pos.avg_entry_price}</td>
                                                    <td className="py-3">{pos.mark_price}</td>
                                                    <td className="py-3">
                                                        <Badge
                                                            bg="info"
                                                            style={{ borderRadius: "20px", padding: "8px 16px" }}
                                                        >
                                                            {pos.position_size}
                                                        </Badge>
                                                    </td>
                                                    <td className="py-3">
                                                        <span
                                                            className={
                                                                parseFloat(pos.unrealized_pnl) >= 0
                                                                    ? "text-success fw-bold"
                                                                    : "text-danger fw-bold"
                                                            }
                                                        >
                                                            {parseFloat(pos.unrealized_pnl) >= 0 ? "+" : "-"}
                                                            {Math.abs(parseFloat(pos.unrealized_pnl)).toFixed(2)}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>



                        <div className="mb-5">
                            <DataTable
                                columns={columns}
                                data={transactions?.data || []}
                                pagination
                                highlightOnHover
                                striped
                                responsive
                                customStyles={{
                                    headCells: {
                                        style: {
                                            fontWeight: "600",
                                            color: "#6c757d",
                                            fontSize: "14px",
                                            paddingTop: "15px",
                                            paddingBottom: "15px",
                                        },
                                    },
                                    rows: {
                                        style: {
                                            minHeight: "60px",
                                            borderBottom: "1px solid #f0f0f0",
                                        },
                                    },
                                }}
                            />

                        </div>




                        <div className="mb-5">
                            <div className="d-flex align-items-center mb-4">
                                <div
                                    className="d-inline-flex align-items-center justify-content-center me-3"
                                    style={{
                                        width: "50px",
                                        height: "50px",
                                        borderRadius: "15px",
                                        backgroundColor: "#f0f2f5",
                                    }}
                                >
                                    <span style={{ fontSize: "20px" }}>💳</span>
                                </div>
                                <div>
                                    <h5 className="mb-1 fw-bold">Wallet Details</h5>
                                    <small>Complete wallet information</small>
                                </div>
                            </div>

                            {loading?.wallet ? (
                                <div className="text-center py-5">
                                    <div style={{ fontSize: "48px", marginBottom: "16px" }}>⏳</div>
                                    <p className="mb-0">Loading wallet data...</p>
                                </div>


                            ) : !walletdata || walletdata?.length === 0 ? (
                                <div className="text-center py-5">
                                    <div style={{ fontSize: "48px", marginBottom: "16px" }}>📭</div>
                                    <p className="mb-0">No wallet data available.</p>
                                </div>

                            ) : (
                                <div className="table-responsive">
                                    <table className="table table-bordered align-middle">
                                        <thead className="table-light">
                                            <tr>
                                                <th scope="col">Name</th>
                                                <th scope="col">Currency</th>
                                                <th scope="col">Main Balance</th>
                                                <th scope="col">Blocked Balance</th>
                                                <th scope="col">Invested Value</th>
                                                <th scope="col">Current Value</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {walletdata?.map((wallet, index) => {
                                                const isINR = wallet?.currency === "INR";
                                                const symbol = isINR ? "₹" : "";

                                                return (
                                                    <tr key={index}>
                                                        <td>{wallet?.name}</td>
                                                        <td>{wallet?.currency}</td>

                                                        <td>
                                                            {symbol}
                                                            {Number(wallet?.main_balance || 0).toLocaleString(undefined, {
                                                                minimumFractionDigits: 3,
                                                                maximumFractionDigits: 3,
                                                            })}
                                                        </td>

                                                        <td>
                                                            {symbol}
                                                            {Number(wallet?.blocked_balance_order || 0).toLocaleString(undefined, {
                                                                minimumFractionDigits: 3,
                                                                maximumFractionDigits: 3,
                                                            })}
                                                        </td>

                                                        <td>
                                                            {symbol}
                                                            {Number(wallet?.invested_value || 0).toLocaleString(undefined, {
                                                                minimumFractionDigits: 3,
                                                                maximumFractionDigits: 3,
                                                            })}
                                                        </td>

                                                        <td>
                                                            {symbol}
                                                            {Number(wallet?.current_value || 0).toLocaleString(undefined, {
                                                                minimumFractionDigits: 3,
                                                                maximumFractionDigits: 3,
                                                            })}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>

                                    </table>
                                </div>

                            )}
                        </div>

                    </div>



                </Card>
            </div>
        </div>
    );
};

export default Wallet;